import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSEO } from "../../context/SEOContext";
const ReturnPolicy = () => {
  const { t } = useTranslation();
  const setSeo = useSEO();
  useEffect(() => {
    setSeo({
      title: t("returnPolicy.meta.title"),
      description: t("returnPolicy.meta.description"),
      keywords: t("returnPolicy.meta.keywords"),
      favicon: "/faviconnew.png",
    });
  }, [setSeo, t]);
  return (
    <>
      <div className="container py-5">
        <div className="row">
          <div className="col-lg-12 mb-5 text-center">
            <h4 className="fw-light"> {t("Return Policy")}</h4>
          </div>
          <div className="col-lg-12 mb-5">
            <p>{t("intro")}</p>

            <h4>
              <strong>{t("section1.title")}</strong>
            </h4>
            <ul>
              <li>{t("section1.item1")}</li>
              <li>
                {t("section1.item2.prefix")}{" "}
                <a href="mailto:customer.support@mukemel.com">
                  customer.support@mukemel.com
                </a>{" "}
                {t("section1.item2.suffix")}
              </li>
            </ul>

            <h4>
              <strong>{t("section2.title")}</strong>
            </h4>
            <ul>
              <li>{t("section2.item1")}</li>
              <li>{t("section2.item2")}</li>
              <li>
                {t("section2.item3.prefix")}
                <strong>{t("section2.item3.days")}</strong>{" "}
                {t("section2.item3.suffix")}
              </li>
            </ul>

            <h4>
              <strong>{t("section3.title")}</strong>
            </h4>
            <ul>
              <li>{t("section3.item1")}</li>
              <li>
                {t("section3.item2.prefix")}
                <strong>Mükemel.com</strong> {t("section3.item2.suffix")}
              </li>
              <li>
                {t("section3.item3.prefix")}
                <strong> {t("section3.item3.days")}</strong>
                {t("section3.item3.suffix")}
              </li>
            </ul>

            <h4>
              <strong>{t("section4.title")}</strong>
            </h4>
            <ul>
              <li>{t("section4.item1")}</li>
            </ul>

            <h4>
              <strong>{t("section5.title")}</strong>
            </h4>
            <p>{t("contact.intro")}</p>
            <ul>
              <li>
                {t("contact.email.label")} :{" "}
                <a href="mailto:customer.support@mukemel.com">
                  {" "}
                  customer.support@mukemel.com
                </a>
              </li>
              <li>
                {t("contact.phone.label")} :{" "}
                <a href="tel:+905365049119">+90 536 504 91 19</a>
              </li>
              <li>
                {t("contact.hours.label")} : {t("contact.hours.value")}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReturnPolicy;
